import { formatDecimalBR, parseDecimalBR, type DecimalMode } from "@cafegestor/shared";
import type { Ref } from "react";
import { Input } from "./ui";

type ValueChange = (e: { target: { value: string } }) => void;

/**
 * Campo de número no padrão brasileiro: aceita "10.000,00", "10000,00" ou "10000.00" e, ao
 * sair do campo, mostra o valor formatado (10.000,00). A conversão para o formato da API é
 * feita pela validação compartilhada; o texto que não é número fica como está, para a
 * mensagem de erro explicar.
 */
export function DecimalInput({
  value,
  onChange,
  mode = "dinheiro",
  places = mode === "dinheiro" ? 2 : undefined,
  className,
  disabled,
  id,
  "aria-label": ariaLabel,
  inputRef,
  placeholder,
  invalid,
  describedBy,
}: {
  value: string;
  onChange: ValueChange;
  mode?: DecimalMode;
  places?: number | undefined;
  className?: string;
  disabled?: boolean;
  id?: string;
  "aria-label"?: string;
  inputRef?: Ref<HTMLInputElement>;
  placeholder?: string;
  /** campo com erro (borda e leitor de tela) */
  invalid?: boolean;
  /** id da mensagem de erro do campo */
  describedBy?: string;
}) {
  return (
    <Input
      {...(id !== undefined ? { id } : {})}
      {...(ariaLabel !== undefined ? { "aria-label": ariaLabel } : {})}
      {...(className !== undefined ? { className } : {})}
      {...(disabled !== undefined ? { disabled } : {})}
      {...(inputRef !== undefined ? { ref: inputRef } : {})}
      {...(placeholder !== undefined ? { placeholder } : {})}
      {...(invalid ? { "aria-invalid": true } : {})}
      {...(describedBy !== undefined ? { "aria-describedby": describedBy } : {})}
      inputMode="decimal"
      value={value}
      onChange={(e) => onChange({ target: { value: e.target.value } })}
      onBlur={() => {
        const canonical = parseDecimalBR(value, mode);
        if (canonical === null) return;
        const formatted = formatDecimalBR(canonical, places);
        if (formatted !== value) onChange({ target: { value: formatted } });
      }}
    />
  );
}
